export default __webpack_public_path__ + "static/media/dash.aa708fcc.png";